const SIGNATURE_RECTANGLE = {
  WIDTH: 130,
  HEIGHT: 60,
}

export { SIGNATURE_RECTANGLE }
